import React from 'react';
import { title } from 'utils/storyUtils';

import Activity, { Props } from './Activity';

import colors from '../styles/colors';

interface Module {
  default: React.FunctionComponent;
}

export default {
  title: title('Icons'),
  component: Activity, // all icons have same props
  parameters: {
    // disable automatic a11y check as the plugin nearly freezes your entire
    // browser trying to check these stories
    a11y: { manual: true },
  },
};

// @ts-ignore shortcut for dynamically loaded all icons from directory
function requireAll(requireContext): Module[] {
  return requireContext.keys().map(requireContext);
}

function loadIcons(): React.FC[] {
  return requireAll(require.context('.', false, /^\.\/[A-Za-z1-9]+\.tsx$/)).map(
    module => module.default,
  );
}

const Icons = (style: object) => (
  <div style={{ color: '#111', maxWidth: 250, ...style }}>
    {loadIcons().map(IconComponent => (
      <dl
        key={IconComponent.name}
        style={{
          columns: 2,
          margin: 0,
          paddingTop: '1em',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <dd
          style={{
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            padding: '0 24px 0 8px',
          }}
        >
          <IconComponent />
        </dd>
        <dt style={{ display: 'flex', alignItems: 'center' }}>
          <pre>
            {'<'}
            {IconComponent.displayName}
            {' />'}
          </pre>
        </dt>
      </dl>
    ))}
  </div>
);

export const Showcase = (props: Props) => Icons({});

export const ColorTest = (props: Props) => Icons({ color: colors.red600 });

export const BackgroundColorTest = (props: Props) =>
  Icons({ backgroundColor: colors.black200 });

export const ZoomTest = (props: Props) => Icons({ zoom: 2 });
